<div style="display: flex;justify-content: center;margin-top: 30px">
  <div class="container1" style="width: 85%">
    <h2 >Retorno de Equipos</h2>

    <div *ngIf="!loading" class="divButtons" style="justify-content: flex-start">

      <mat-form-field appearance="fill" class="buttonFilter">
        <mat-label>MARCA</mat-label>
        <mat-select [(value)]="selectMarca" (selectionChange)="applyFilterSelect()">
          <mat-option value={{null}}>No seleccionar</mat-option>
          <mat-option *ngFor="let marca of arrayMarcas" value={{marca}}>{{marca}}</mat-option>
        </mat-select>
      </mat-form-field>


      <mat-form-field appearance="fill" class="buttonFilter">
        <mat-label>MODELO</mat-label>
        <mat-select [(value)]="selectModelo" (selectionChange)="applyFilterSelect()">
          <mat-option value={{null}}>No seleccionar</mat-option>
          <mat-option *ngFor="let modelo of arrayModelos" value={{modelo}}>{{modelo}}</mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="fill" class="buttonFilter">
        <mat-label>TALLA</mat-label>
        <mat-select [(value)]="selectTalla" (selectionChange)="applyFilterSelect()">
          <mat-option value={{null}}>No seleccionar</mat-option>
          <mat-option *ngFor="let talla of arrayTallas" value={{talla}}>{{talla}}</mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="fill" class="buttonFilter">
        <mat-label>CATEGORÍA</mat-label>
        <mat-select [(value)]="selectCategoria" (selectionChange)="applyFilterSelect()">
          <mat-option value={{null}}>No seleccionar</mat-option>
          <mat-option *ngFor="let categoria of arrayCategorias" value={{categoria}}>{{categoria}}</mat-option>
        </mat-select>
      </mat-form-field>

    </div>

    <div *ngIf="!loading" style="display: flex;justify-content: center;margin-top: 1rem">
      <mat-form-field appearance="outline" class="divInputSearch">
        <mat-label>Filtrar</mat-label>
        <input matInput (keyup)="applyFilter($event)" placeholder="Filtrar Búsqueda"/>
      </mat-form-field>
    </div>

    <div *ngIf="loading" class="spinner">
      <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
    </div>

        <mat-table *ngIf="!loading" [dataSource]="dataSource"  class="example-container mat-elevation-z8" >

          <ng-container matColumnDef="codigo">
            <mat-header-cell  *matHeaderCellDef>Código</mat-header-cell>
            <mat-cell  *matCellDef="let element">{{ element?.equipoInfo.codigo }}</mat-cell>
          </ng-container>

          <ng-container matColumnDef="nombre">
            <mat-header-cell  *matHeaderCellDef>Nombre</mat-header-cell>
            <mat-cell  *matCellDef="let element">{{ element?.equipoInfo.nombreEquipo }}</mat-cell>
          </ng-container>

          <ng-container matColumnDef="categoria">
            <mat-header-cell  *matHeaderCellDef>Categoría</mat-header-cell>
            <mat-cell *matCellDef="let element">{{ element?.equipoInfo.categoria }}</mat-cell>
          </ng-container>

          <ng-container matColumnDef="marca">
            <mat-header-cell  *matHeaderCellDef>Marca</mat-header-cell>
            <mat-cell *matCellDef="let element">{{ element?.equipoInfo.marcaEquipo }}</mat-cell>
          </ng-container>

          <ng-container matColumnDef="modelo">
            <mat-header-cell  *matHeaderCellDef>Modelo</mat-header-cell>
            <mat-cell *matCellDef="let element">{{ element?.equipoInfo.modeloEquipo }}</mat-cell>
          </ng-container>

          <ng-container matColumnDef="talla">
            <mat-header-cell  *matHeaderCellDef>Talla</mat-header-cell>
            <mat-cell *matCellDef="let element">{{ element?.equipoInfo.tallaEquipo }}</mat-cell>
          </ng-container>

          <ng-container matColumnDef="fileAsignado">
            <mat-header-cell  *matHeaderCellDef>File</mat-header-cell>
            <mat-cell  *matCellDef="let element">{{ element?.fileNumber }}</mat-cell>
          </ng-container>

    <!--      <ng-container matColumnDef="observacion">-->
    <!--        <mat-header-cell  *matHeaderCellDef>Observaciones</mat-header-cell>-->
    <!--        <mat-cell *matCellDef="let element">{{ element?.observacionEquipo }}</mat-cell>-->
    <!--      </ng-container>-->

    <!--      <ng-container matColumnDef="valoracion">-->
    <!--        <mat-header-cell  *matHeaderCellDef>Valoración</mat-header-cell>-->
    <!--        <mat-cell *matCellDef="let element">{{ element?.valoracionEquipo }}</mat-cell>-->
    <!--      </ng-container>-->

          <ng-container matColumnDef="modificar">
            <th mat-header-cell *matHeaderCellDef> Retornar </th>
            <td mat-cell *matCellDef="let element">
              <button mat-icon-button color="primary" (click)="openDialogModify(element)">
                <mat-icon>edit</mat-icon>
              </button>
            </td>
          </ng-container>

          <mat-header-row  *matHeaderRowDef="displayedColumns"></mat-header-row>
          <mat-row  *matRowDef="let row; columns: displayedColumns"></mat-row>

        </mat-table>

      <div [hidden]="loading">
        <mat-paginator [pageSizeOptions]="[5, 10, 20]"
                       showFirstLastButtons>
        </mat-paginator>
      </div>

  </div>
</div>
